import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api'
import { PublicApiId } from '../types/public-api-settings-interface'

export const useDeletePublicApiKey = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.delete>({
    method: RequestMethodsEnum.delete,
  })

  return {
    deletePublicApiKey: async (id: PublicApiId) => await fetcher(`${PUBLIC_API_SETTINGS}/${id}`),
  }
}
